/**
 * 菜单名称翻译字典（按语言分组）
 *
 * 菜单名称来自后端数据库（sys_permission.name，中文），此处维护「中文原名 → 译文」映射。
 * 查找规则：先按当前语言取分组，再按中文原名取译文；任何一级缺失都回退显示中文原文。
 *
 * 维护说明：
 * 1. 后端新增/修改菜单后，需在此同步补充对应语言的映射，否则该菜单在非中文语言下仍显示中文
 * 2. 新增语言时，在本对象中平级增加一个语言分组即可（如 'fr-FR': { ... }）
 * 3. en-US 分组按子系统分块维护，覆盖全站菜单树（含 [按钮] 权限项）；
 *    同名词条已尽量沿用 src/i18n/lang/en/modules/ 各业务词典的既有译法
 * 4. 语境约定：系统管理下的「用户管理/用户列表」指系统账号（User），表务/营收下的
 *    「用水户/用户档案」指用水客户（Customer）；首页=Home，工作台=Workbench，消息中心=Message Center
 */
export default {
  'en-US': {
    // ===== 通用/平台基础（系统监控） =====
    '系统监控': 'System Monitor',
    '路由网关': 'Routing Gateway',
    '在线用户': 'Online Users',
    '在线文档': 'Online Documentation',
    '日志管理': 'Log Management',
    '性能监控': 'Performance Monitoring',
    'Tomcat信息': 'Tomcat Info',
    '服务器信息': 'Server Info',
    'Redis监控': 'Redis Monitor',
    '磁盘监控': 'Disk Monitoring',
    'JVM信息': 'JVM Info',
    '请求追踪': 'Request Tracing',
    '数据日志': 'Data Log',
    'SQL监控': 'SQL Monitor',
    '定时任务': 'Scheduled Job',
    // ===== 报表设计 =====
    '报表设计': 'Report Design',
    '生产销售监控': 'Production & Sales Monitoring',
    '智慧物流监控': 'Smart Logistics Monitoring',
    '积木报表设计': 'Jimu Report Design',
    // ===== 一张图 =====
    '一张图': 'One Map',
    // ===== 运营分析系统 =====
    '运营分析系统': 'Operations Analysis System',
    '档案管理': 'Archive Management',
    '费用管理': 'Fee Management',
    '收费项目': 'Charge Item',
    '价格信息': 'Price Info',
    '售水管理': 'Water Sales Management',
    '系统管理': 'System Management',
    '用户管理': 'User Management',
    '角色管理': 'Role Management',
    '菜单管理': 'Menu Management',
    '公司管理': 'Company Management',
    '部门管理': 'Department Management',
    '职务管理': 'Position Management',
    '我的部门': 'My Department',
    '通讯录': 'Contacts',
    '数据字典': 'Data Dictionary',
    '系统通告': 'System Announcement',
    '系统日志': 'System Log',
    '营业收费': 'Billing & Collection',
    '缴费大厅': 'Payment Hall',
    '缴费': 'Payment',
    '补水': 'Water Supplement',
    '退费': 'Refund',
    '撤销': 'Revoke',
    '用户卡充值': 'Customer Card Recharge',
    '开阀': 'Open Valve',
    '关阀': 'Close Valve',
    '缴费记录': 'Payment Records',
    '用户余额': 'Customer Balance',
    '营收对账': 'Revenue Reconciliation',
    '开票记录': 'Invoice Records',
    '报表统计': 'Report Statistics',
    '营收报表': 'Revenue Reports',
    '日报表': 'Daily Statement',
    '月报表': 'Monthly Statement',
    '年报表': 'Annual Statement',
    '销售汇总报表': 'Sales Summary Report',
    '售水统计报表': 'Water Sales Statistics Report',
    '用水统计报表': 'Water Usage Statistics Report',
    '用量报表': 'Usage Reports',
    '用水量查询': 'Water Usage Query',
    '日用量报表': 'Daily Usage Report',
    '编辑': 'Edit',
    '月用量报表': 'Monthly Usage Report',
    '区域用量报表': 'Area Usage Report',
    '结算报表': 'Settlement Report',
    '用量明细查询': 'Usage Detail Query',
    '运维报表': 'O&M Reports',
    '电池电压': 'Battery Voltage',
    '信号分析': 'Signal Analysis',
    '上报分析': 'Reporting Analysis',
    '上报率分析': 'Reporting Rate Analysis',
    '辅助服务': 'Auxiliary Services',
    '批量任务列表': 'Batch Task List',
    '补水审核员设置': 'Water Supplement Reviewer Settings',
    '我的审核': 'My Reviews',
    '我的申请': 'My Applications',
    '我的消息': 'My Messages',
    '用户缴费管理': 'Customer Payment Management',
    '缴费统计': 'Payment Statistics',
    '收费报表': 'Charge Report',
    '综合查询': 'Comprehensive Query',
    '票据信息': 'Bill Info',
    '在线开发': 'Online Development',
    'Online表单开发': 'Online Form Development',
    'AUTO复制表单': 'AUTO Copy Form',
    'Online报表配置': 'Online Report Configuration',
    '系统编码规则': 'System Coding Rule',
    '系统校验规则': 'System Validation Rule',
    'AUTO在线表单ERP': 'AUTO Online Form ERP',
    '多数据源管理': 'Multi-Data Source Management',
    'AUTO动态表单': 'AUTO Dynamic Form',
    'AUTO在线表单': 'AUTO Online Form',
    'AUTO在线报表': 'AUTO Online Report',
    'AUTO树表单列表': 'AUTO Tree Form List',
    'AUTO在线内嵌子表': 'AUTO Online Embedded Sub-table',
    '首页': 'Home',
    // ===== 工程报装系统 =====
    '工程报装系统': 'Engineering Installation System',
    '审批管理': 'Approval Management',
    '报装申请': 'Installation Application',
    '工程部审核': 'Engineering Department Review',
    '录入勘测信息': 'Enter Survey Information',
    '录入图纸和预算': 'Enter Drawings & Budget',
    '审批图纸和预算': 'Approve Drawings & Budget',
    '录入合同': 'Enter Contract',
    '审批合同': 'Approve Contract',
    '财务确认': 'Financial Confirmation',
    '领导审批派单': 'Leader Approval & Dispatch',
    '录入施工文件': 'Enter Construction Documents',
    '报装记录': 'Installation Records',
    '工程验收': 'Project Acceptance',
    '归档': 'Archive',
    '流程配置': 'Process Configuration',
    '建筑公司': 'Construction Company',
    '报装资料': 'Installation Documents',
    '勘测信息': 'Survey Information',
    '图纸和预算信息': 'Drawings & Budget Information',
    '合同信息': 'Contract Information',
    '施工信息': 'Construction Info',
    '已结束': 'Finished',
    '我的待办': 'My To-Do',
    '我的已办': 'My Done',
    '待签': 'Pending Signature',
    '全部待办': 'All To-Do',
    // ===== 表务管理系统 =====
    '表务管理系统': 'Meter Management System',
    '区域管理': 'Area Management',
    '新增': 'Add',
    '删除': 'Delete',
    '表具明细': 'Meter Details',
    '用户档案': 'Customer Archive',
    '列表': 'List',
    '批量删除': 'Batch Delete',
    '激活': 'Activate',
    '过户': 'Transfer',
    '换表': 'Meter Replacement',
    '新建档案': 'New Archive',
    '调价': 'Price Adjustment',
    '卡操作': 'Card Operation',
    '报停': 'Suspension',
    '销户': 'Account Cancellation',
    '基础信息管理': 'Basic Information Management',
    '表口径': 'Meter Caliber',
    '添加': 'Add',
    '表类型': 'Meter Type',
    '用户类型': 'Customer Type',
    '用水户型': 'Household Type',
    'IOT应用管理': 'IoT Application Management',
    '档案查询': 'Archive Query',
    '换表记录': 'Meter Replacement Records',
    '过户记录': 'Ownership Transfer Records',
    '用户统计': 'Customer Statistics',
    '用户调价': 'Customer Price Adjustment',
    '批量调价': 'Batch Price Adjustment',
    '水表统计(按表口径)': 'Water Meter Statistics (by Meter Caliber)',
    '水表统计(按表类型)': 'Water Meter Statistics (by Meter Type)',
    '报停记录': 'Suspension Records',
    '报停恢复': 'Service Resumption',
    '销户记录': 'Account Cancellation Records',
    '表具生命周期': 'Meter Lifecycle',
    '轮检管理': 'Rotation Inspection Management',
    '维修管理': 'Repair Management',
    '返厂管理': 'Factory Return Management',
    '报废管理': 'Scrapping Management',
    '大用户管理': 'Large Customer Management',
    '大用户监控': 'Large Customer Monitoring',
    '大用户分析': 'Large Customer Analysis',
    // ===== 集中抄表系统 =====
    '集中抄表系统': 'Centralized Meter Reading System',
    '表具实时数据': 'Meter Real-time Data',
    '命令调试按钮': 'Command Debug Button',
    '查询命令队列按钮': 'Query Command Queue Button',
    '表具历史数据': 'Meter History Data',
    '告警管理': 'Alarm Management',
    '异常状态查询': 'Abnormal Status Query',
    '实时异常查询': 'Real-time Anomaly Query',
    '历史异常查询': 'Historical Anomaly Query',
    '零流量查询': 'Zero Flow Query',
    '未上报查询': 'Not Reported Query',
    '流量告警列表': 'Flow Alarm List',
    '流量告警配置': 'Flow Alarm Configuration',
    '命令管理': 'Command Management',
    '已开户表命令管理': 'Command Management for Registered Meters',
    'WN100表类型': 'WN100 Meter Type',
    '终端参数设置': 'Terminal Parameter Settings',
    '查询终端参数': 'Query Terminal Parameters',
    '查询基础信息': 'Query Basic Info',
    '查询实时数据': 'Query Real-time Data',
    '历史日结信息查询': 'Daily Settlement History Query',
    '阀门动作记录查询': 'Valve Action Record Query',
    '联网失败记录查询': 'Network Failure Record Query',
    '终端故障记录查询': 'Terminal Fault Record Query',
    '开阀(强制)': 'Open Valve (Forced)',
    '关阀(强制)': 'Close Valve (Forced)',
    '取消阀控': 'Cancel Valve Control',
    '修改运行秘钥': 'Modify Operating Key',
    '修改根秘钥': 'Modify Root Key',
    'MN100表类型': 'MN100 Meter Type',
    '读取表具信息': 'Read Meter Info',
    '读表号': 'Read Meter No.',
    '读取表上报参数': 'Read Meter Report Parameters',
    '读取表网络参数': 'Read Meter Network Parameters',
    '读取表历史数据': 'Read Meter History Data',
    '读取模组IMEI号': 'Read Module IMEI',
    '读取模组版本号': 'Read Module Version',
    '读取模组版本状态': 'Read Module Version Status',
    '读取最近10次阀门动作原因': 'Read Last 10 Valve Action Reasons',
    '读取程序版本信息': 'Read Program Version Info',
    '读取最近10次联网失败原因': 'Read Last 10 Network Failure Reasons',
    '读取最近10次表端故障原因': 'Read Last 10 Meter Fault Reasons',
    '读取表端最近10次磁干扰故障': 'Read Last 10 Magnetic Interference Faults',
    '校时': 'Time Sync',
    '写表号': 'Write Meter No.',
    '强制开关阀': 'Force Valve Control',
    '修改运行秘密钥': 'Modify Operating Key',
    '配置表上报参数': 'Configure Meter Report Parameters',
    '配置表网络参数': 'Configure Meter Network Parameters',
    '配置表工作参数': 'Configure Meter Working Parameters',
    '表端自检功能': 'Meter Self-Check',
    '清除表端故障': 'Clear Meter Faults',
    '模块初始化配置': 'Module Initialization Config',
    '读取表工作参数': 'Read Meter Working Parameters',
    'MN100-2D表类型': 'MN100-2D Meter Type',
    '配置阀门状态': 'Configure Valve Status',
    'Y10-QN表类型': 'Y10-QN Meter Type',
    '开关阀': 'Open/Close Valve',
    'Y17-N表类型': 'Y17-N Meter Type',
    'Y18-N表类型': 'Y18-N Meter Type',
    'Y19-N表类型': 'Y19-N Meter Type',
    '命令服务队列': 'Command Service Queue',
    'FOTA升级': 'FOTA Upgrade',
    '软件包管理': 'Software Package Management',
    'fota升级队列': 'FOTA Upgrade Queue',
    // ===== 系统大屏 =====
    '系统大屏': 'System Dashboard',
    '大屏展示': 'Dashboard Display',
    '水质监测系统': 'Water Quality Monitoring System',
    // ===== 工单管理系统 =====
    '工单管理系统': 'Work Order Management System',
    '流程管理': 'Process Management',
    '工单记录': 'Work Order Records',
    '故障报修': 'Fault Repair',
    '表单配置': 'Form Configuration',
    '微信申请审批': 'WeChat Application Approval',
    '工单申请': 'Work Order Application',
    '故障报修审批': 'Fault Repair Approval',
    '我的待签': 'My Pending Signature',
    '水厂工单记录': 'Water Plant Work Order Records',
    '外围工单记录': 'External Work Order Records',
    '人员配置': 'Personnel Configuration',
    '处理人员': 'Handler',
    '处理班组': 'Handling Team',
    // ===== 巡检管理系统 =====
    '巡检管理系统': 'Inspection Management System',
    '路线管理': 'Route Management',
    '设备管理': 'Device Management',
    '巡检计划': 'Inspection Plan',
    '巡检任务': 'Inspection Task',
    '巡检结果': 'Inspection Result',
    '巡检人员': 'Inspection Personnel',
    '巡检班组': 'Inspection Team',
    '管网管理': 'Pipe Network Management',
    '管网总览': 'Pipe Network Overview',
    '管网查询': 'Pipe Network Query',
    '管网编辑': 'Pipe Network Editing',
    '管网统计': 'Pipe Network Statistics',
    '管网分析': 'Pipe Network Analysis',
    '管网检查': 'Pipe Network Check',
    '管网巡检': 'Pipe Network Inspection',
    '管网工具': 'Pipe Network Tools',
    'FUXA工艺图': 'FUXA Process Diagram',
    '首页1': 'Home 1',
    '巡检区域': 'Inspection Area',
    '问题管理': 'Problem Management',
    '水厂巡检计划': 'Water Plant Inspection Plan',
    '水厂巡检任务': 'Water Plant Inspection Task',
    '水厂巡检结果': 'Water Plant Inspection Result',
    '水厂问题管理': 'Water Plant Problem Management',
    '外围巡检计划': 'External Inspection Plan',
    '外围巡检任务': 'External Inspection Task',
    '外围巡检结果': 'External Inspection Result',
    '外围问题管理': 'External Problem Management',
    '营收巡检计划': 'Revenue Inspection Plan',
    '营收巡检任务': 'Revenue Inspection Task',
    '营收巡检结果': 'Revenue Inspection Result',
    '营收问题管理': 'Revenue Problem Management',
    // ===== OA办公 =====
    'OA办公': 'OA Office',
    '留言管理': 'Message Management',
    '营业网点': 'Business Outlets',
    '停水信息': 'Water Outage Information',
    '流程模型': 'Process Model',
    '业务表单': 'Business Form',
    '在线表单设计': 'Online Form Design',
    '任务管理': 'Task Management',
    '所有任务': 'All Tasks',
    '委派': 'Delegate',
    '转办': 'Transfer',
    '我的任务': 'My Tasks',
    '待办任务': 'To-Do Tasks',
    '抄送我的': 'CC to Me',
    '我的抄送': 'My CC',
    '已办任务': 'Done Tasks',
    '自定义任务': 'Custom Task',
    '流程申请': 'Process Application',
    '公告管理': 'Announcement Management',
    '公告发布': 'Announcement Publishing',
    '行政公告': 'Administrative Announcement',
    '红头文件': 'Red-Head Document',
    '新闻资讯': 'News & Information',
    '赏罚通报': 'Reward & Punishment Report',
    '市场观察': 'Market Watch',
    '公告查看': 'Announcement Viewing',
    '行政管理': 'Administration Management',
    '考勤管理': 'Attendance Management',
    '请假申请': 'Leave Application',
    '外出申请': 'Outing Application',
    '加班申请': 'Overtime Application',
    '印章管理': 'Seal Management',
    '用印申请(非合同)': 'Seal Use Application (Non-Contract)',
    '用印申请(合同)': 'Seal Use Application (Contract)',
    '印章借用申请': 'Seal Borrowing Application',
    '个人管理': 'Personal Management',
    '我的日历': 'My Calendar',
    '日程安排': 'Schedule',
    '工作台': 'Workbench',
    '工作记录': 'Work Records',
    '日报管理': 'Daily Report Management',
    '周报管理': 'Weekly Report Management',
    '月报管理': 'Monthly Report Management',
    '年度汇报': 'Annual Report',
    '工作台管理': 'Workbench Management',
    '工作台配置': 'Workbench Configuration',
    // ===== APP菜单 =====
    'APP菜单': 'APP Menu',
    '换表管理': 'Meter Replacement Management',
    '远程操作': 'Remote Operation',
    '远程阀控': 'Remote Valve Control',
    '自动上传': 'Auto Upload',
    '表用户': 'Metered Customer',
    '档案变更': 'Archive Change',
    '充值记录': 'Recharge Records',
    '巡查点查询': 'Patrol Point Query',
    '巡检管理': 'Inspection Management',
    '工单服务': 'Work Order Service',
    '压力表统计': 'Pressure Gauge Statistics',
    '巡检任务池': 'Inspection Task Pool',
    '报装服务': 'Installation Service',
    'OA审批': 'OA Approval',
    '报修审批': 'Fault Repair Approval',
    '水厂巡检任务池': 'Water Plant Inspection Task Pool',
    '外围巡检任务池': 'External Inspection Task Pool',
    '营收巡检任务池': 'Revenue Inspection Task Pool',
    // ===== 水质检测系统 =====
    '水质检测系统': 'Water Quality Testing System',
    '水质监测': 'Water Quality Monitoring',
    '实时数据': 'Real-time Data',
    '分钟数据': 'Minute Data',
    '管网监测': 'Pipe Network Monitoring',
    '历史数据': 'Historical Data',
    '服务队列按钮': 'Service Queue Button',
    '服务队列': 'Service Queue',
    '阀门开度': 'Valve Opening',
    '命令下发': 'Send Command',
    '电磁流量计': 'Electromagnetic Flow Meter',
    '井电双控': 'Well & Power Dual Control',
    '供水控制': 'Water Supply Control',
    '视频管理': 'Video Management',
    '太阳能设备': 'Solar Equipment',
    '用电信息': 'Power Usage Information',
    '管网概览': 'Pipe Network Overview',
    // ===== 客服热线 =====
    '客服热线': 'Customer Service Hotline',
    '话务员管理': 'Operator Management',
    '来电记录': 'Incoming Call Records',
    '话务台': 'Attendant Console',
    '知识库': 'Knowledge Base',
    // ===== 通知中心系统 =====
    '通知中心系统': 'Notification Center System',
    '消息模板配置': 'Message Template Configuration',
    '告警规则配置': 'Alarm Rule Configuration',
    '告警消息记录': 'Alarm Message Records',
    // ===== DMA分区计量系统 =====
    'DMA分区计量系统': 'DMA District Metering System',
    '综合展示': 'Comprehensive Display',
    '预警控漏': 'Early-Warning Leakage Control',
    '在线监控': 'Online Monitoring',
    '最小流量': 'Minimum Flow',
    '分区控漏': 'District Leakage Control',
    '小区治理': 'Community Governance',
    '最小流量分析': 'Minimum Flow Analysis',
    '供水量分析(删除)': 'Water Supply Analysis (Deleted)',
    '漏损率分析': 'Leakage Rate Analysis',
    '管理控漏': 'Management-Based Leakage Control',
    '营收反查': 'Revenue Cross-Check',
    '系统设置': 'System Settings',
    '分区管理': 'District Management',
    '最小流量配置': 'Minimum Flow Configuration',
    '物联配置': 'IoT Configuration',
    '分区概览': 'District Overview',
    '渲染管理': 'Rendering Management',
    '审核管理': 'Review Management',
    // ===== 常见案例（Demo） =====
    '常见案例': 'Common Cases',
    '表格合计': 'Table Total',
    '异步树列表Demo': 'Async Tree List Demo',
    '对象存储': 'Object Storage',
    'online订单管理': 'Online Order Management',
    'online用户报表': 'Online Customer Report',
    '图片裁剪': 'Image Cropping',
    'JVXETable示例': 'JVXETable Demo',
    '普通示例': 'Basic Demo',
    '布局模板': 'Layout Template',
    '即时保存': 'Instant Save',
    '弹出子表': 'Popup Sub-table',
    '无痕刷新': 'Seamless Refresh',
    '一对多JVxeTable': 'One-to-Many JVxeTable',
    '第三方APP消息测试': 'Third-Party APP Message Test',
    '表格合计News': 'Table Total News',
    '图片拖拽排序': 'Image Drag & Drop Sorting',
    'helloworld': 'Hello World',
    '分屏': 'Split Screen',
    '单表模型示例': 'Single Table Model Demo',
    'demo添加功能': 'Demo Add Function',
    '内嵌Table': 'Embedded Table',
    '图片翻页': 'Image Paging',
    '图片预览': 'Image Preview',
    '一对多erp风格示例': 'One-to-Many ERP Style Demo',
    'JEditableTable示例': 'JEditableTable Demo',
    '自定义组件': 'Custom Component',
    'JEECG官方网站': 'JEECG Official Website',
    '一对多JEditable': 'One-to-Many JEditable',
    '数据回执模拟': 'Data Receipt Simulation',
    'PDF预览': 'PDF Preview',
    '打印测试': 'Print Test',
    '一对多示例': 'One-to-Many Demo',
    // ===== 门户示例（结果页/详情页/列表页/消息中心/个人页/异常页） =====
    '结果页': 'Result Page',
    '成功': 'Success',
    '失败': 'Failed',
    '详情页': 'Detail Page',
    '高级详情页': 'Advanced Detail Page',
    '基础详情页': 'Basic Detail Page',
    '列表页': 'List Page',
    '用户列表': 'User List',
    '查询表格': 'Query Table',
    '角色列表': 'Role List',
    '权限列表': 'Permission List',
    '卡片列表': 'Card List',
    '内联编辑表格': 'Inline Editable Table',
    '标准列表': 'Standard List',
    '搜索列表': 'Search List',
    '搜索列表（文章）': 'Search List (Articles)',
    '搜索列表（应用）': 'Search List (Applications)',
    '搜索列表（项目）': 'Search List (Projects)',
    '消息中心': 'Message Center',
    '消息管理': 'Message Management',
    '模板管理': 'Template Management',
    '个人页': 'Personal Page',
    '个人设置': 'Personal Settings',
    '基本设置': 'Basic Settings',
    '账户绑定': 'Account Binding',
    '个性化设置': 'Personalization Settings',
    '安全设置': 'Security Settings',
    '新消息通知': 'New Message Notification',
    '个人中心': 'Profile',
    '我的任务表单': 'My Task Form',
    '异常页': 'Exception Page',
    '403': '403',
    '500': '500',
    '404': '404',
    // ===== 系统管理（Jeecg 内置） =====
    '租户管理': 'Tenant Management',
    '流程自定义': 'Custom Process',
    '添加按钮': 'Add Button',
    '用户编辑': 'User Edit',
    '表单性别可见': 'Gender Field Visible',
    '禁用生日字段': 'Disable Birthday Field',
    '手机号禁用': 'Disable Mobile Phone',
    '菜单管理(老)': 'Menu Management (Legacy)',
    '分类字典': 'Category Dictionary',
    // ===== 表单页 =====
    '表单页': 'Form Page',
    '基础表单': 'Basic Form',
    '分步表单': 'Step Form',
    '高级表单': 'Advanced Form',
    // ===== 在线开发（Jeecg 内置补充） =====
    'AUTO在线表单TAB': 'AUTO Online Form TAB',
    '代码生成按钮': 'Code Generation Button',
    // ===== 统计报表 =====
    '统计报表': 'Statistics Report',
    'ViserChartDemo': 'ViserChartDemo',
    'Online报表示例': 'Online Report Demo',
    '布局统计报表': 'Layout Statistics Report'
  }
}
